import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import Phone from "./Phone";

import { ReactComponent as CompanyLogo } from "../../assets/images/logo.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: theme.spacing(3, 2, 3, 2.5),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(5, 6, 6, 6),
    },
  },
  logo: {
    filter: "grayscale(1) brightness(5)",
    alignSelf: "center",
    [theme.breakpoints.up("md")]: {
      width: "161px",
      height: "42px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "121px",
      height: "33px",
    },
  },
  menu: {
    fontSize: "2.4rem",
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <CompanyLogo className={classes.logo} title="Kostenloser Bußgeldcheck" />

      <Phone />
    </Box>
  );
};

export default Header;
